<script lang="ts">
	import { page } from '$app/state';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	let clientHeight: number | undefined = $state();
	$effect(() => {
		if (clientHeight) {
			window.parent.postMessage(
				{
					type: 'resize-iframe',
					payload: {
						src: page.url.href,
						height: clientHeight
					}
				},
				'*'
			);
		}
	});
</script>

<div class="pt-11" bind:clientHeight>
	<div class="card-container">
		{@render children?.()}
	</div>
</div>
